module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd93b6f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-awesome-swiper/slide.vue
// module id = 9
// module chunks = 8 9